





































import {
  defineComponent,
  PropType,
  computed,
  getCurrentInstance,
  ComponentInternalInstance,
  reactive,
  ref,
} from '@vue/composition-api';

import loginWithWeComHandler from '@/renderer/components/login/compositions/loginWithWeComHandler';
import useLDAPLogin from '@/renderer/components/login/compositions/useLDAPLogin';
import useYufuLogin from '@/renderer/components/login/compositions/useYufuLogin';
import useSSOLogin from '@/renderer/components/login/compositions/useSSOLogin';

import { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import { User } from '@/renderer/scripts/utils/user';
import { windowEnvs } from '@/renderer/scripts/utils/ConstantConfig/PrivateConfig';
import { IS_PRIVATE } from '@/common/constant';
import { LoginTypeKey } from '@/renderer/scripts/utils/user/UserTyping';
import { LoginTypeKeyMap, LoginActionKeyMap } from '@/renderer/scripts/utils/user/UserTypingMap';

import loginWithWeCom from './loginWithWeCom.vue';
import loginWithYufu from './loginWithYufu.vue';
import loginWithSSO from './loginWithSSO.vue';
import loginWithLDAP from './loginWithLDAP.vue';

enum EntranceKey {
  visitor = 'visitor',
  wecom = 'wecom',
  sso = 'sso',
  yufuIdaas = 'yufuIdaas',
  ldap = 'ldap',
}

export default defineComponent({
  name: 'MoreEntrance',
  components: {
    loginWithWeCom,
    loginWithYufu,
    loginWithSSO,
    loginWithLDAP,
  },
  props: {
    loginWay: {
      type: String as PropType<LoginTypeKey>,
      default: User.LoginTypeKey.loginWithPhone,
    },
  },
  setup(props, context) {
    const vm = (getCurrentInstance() as ComponentInternalInstance).proxy;
    const store = vm.$store;
    const { isCustomizedDomain, currentDomain } = CONSTANT_URL;

    const renderEntrance = reactive({
      loginWithWecom: false, // 企微登录入口
      loginWithSSO: false, // SSO登录入口
      loginWithYufu: false, // 腾讯云账号连接器入口
      loginWithLDAP: false, // LDAP登录入口
    });

    const isInMoreEntrance = computed(() => {
      const LoginMoreEntrance = [
        LoginTypeKey.loginWithWecom,
        LoginTypeKey.loginWithYufu,
        LoginTypeKey.loginWithSSO,
        LoginTypeKey.loginWithLDAP,
      ];
      return LoginMoreEntrance.includes(props.loginWay);
    });

    const renderMap = computed(() => {
      const isLoginWithPassword = windowEnvs.loginMainEntrance.includes(User.LoginTypeKey.loginWithPassword);
      const showVisitor = vm.$route.name === 'share' && !isLoginWithPassword;
      return {
        visitor: {
          show: showVisitor,
          content: i18n_t('访客登录'),
          icon: 'vistor-icon',
        },
        wecom: {
          show: renderEntrance.loginWithWecom,
          content: i18n_t('企业微信'),
          icon: 'wecom-icon',
        },
        // sso
        sso: {
          show: renderEntrance.loginWithSSO,
          content: 'SSO',
          icon: 'sso-icon',
        },
        // yufu IDaas
        yufuIdaas: {
          show: renderEntrance.loginWithYufu,
          content: i18n_t('腾讯云账号连接器'),
          icon: 'yufu-icon',
        },
        ldap: {
          show: renderEntrance.loginWithLDAP,
          content: 'Open LDAP/Windows AD',
          icon: 'ldap-icon',
        },
      };
    });

    const { customId: wecomCustomId, enableWeCom, wecomConfig, methods: wecomMethods } = loginWithWeComHandler();
    const { methods: yufuMethods } = useYufuLogin();
    const { methods: ssoMethods } = useSSOLogin();
    const { step, loginConfigList, ldapType, loginFlag, methods: ldapMethods } = useLDAPLogin();

    const methods = {
      initData() {
        if (IS_PRIVATE) {
          windowEnvs.loginMoreEntrance.forEach(loginType => {
            if (loginType === User.LoginTypeKey.loginWithYufu) {
              // 私有化下yufu IDaas账号连接器固定不显示
              renderEntrance[loginType] = false;
            } else {
              renderEntrance[loginType] = true;
            }
          });
        } else {
          Object.assign(renderEntrance, {
            loginWithWecom: true,
            loginWithSSO: true,
            loginWithYufu: true,
            loginWithLDAP: true,
          });
        }
      },
      async clickEntrance(entrance: EntranceKey) {
        const transformKeyMap: Record<EntranceKey, User.LoginTypeKey | 'visitor'> = {
          wecom: User.LoginTypeKey.loginWithWecom,
          sso: User.LoginTypeKey.loginWithSSO,
          yufuIdaas: User.LoginTypeKey.loginWithYufu,
          ldap: User.LoginTypeKey.loginWithLDAP,
          visitor: 'visitor',
        };
        const domainPrefix = (vm.$route.query?.domain_prefix as string) || '';
        switch (entrance) {
          case EntranceKey.wecom:
            {
              // 私有化多租户 打开弹窗
              if (IS_PRIVATE && store.getters.corpList.length > 1) {
                context.emit('change', User.LoginTypeKey.loginWithWecom);
                reporter.report('login_workwechat', { login_workwechat_detail: 'show' });
                return;
              }
              // 自定义域名 || 私有化单租户 需先查询当前企业是否支持企微登录
              const isCustomDomain = isCustomizedDomain || domainPrefix;
              const isOnlyPrivate = IS_PRIVATE && store.getters.corpList.length === 1;
              if (isCustomDomain || isOnlyPrivate) {
                let domain = '';
                if (isCustomDomain) {
                  domain = [domainPrefix, CONSTANT_URL.currentDomain].filter(v => v).join('.');
                } else {
                  domain = `${wecomCustomId.value}.${currentDomain}`;
                }
                await wecomMethods.getWeComConfig(domain);
                if (enableWeCom.value) {
                  context.emit('change', User.LoginTypeKey.loginWithWecom);
                  reporter.report('login_workwechat', { login_workwechat_detail: 'show' });
                } else {
                  tips.error(i18n_t('暂未开启企业微信登录功能，请联系企业管理员'));
                }
                return;
              }
              context.emit('change', User.LoginTypeKey.loginWithWecom);
              reporter.report('login_workwechat', { login_workwechat_detail: 'show' });
            }
            break;
          case EntranceKey.ldap:
            {
              /**
               * 私有化下且已获取到企业id：
               * 单租户：不需要打开ldap弹窗，默认取第一条企业
               * 多租户：需要打开ldap弹窗，用户选择企业
               * */
              if (IS_PRIVATE && store.getters.corpList.length === 1) {
                ldapMethods.initList();
                const result = await ldapMethods.confirmCropId();
                if (!result) return;
              }
              // 自定义域名不需要打开ldap弹窗第一步
              if (isCustomizedDomain || domainPrefix) {
                const domain = [domainPrefix, currentDomain].filter(v => v).join('.');
                const result = await ldapMethods.confirmDomain(domain);
                if (!result) return;
              }
              context.emit('change', transformKeyMap[entrance] || entrance);
            }
            break;
          case EntranceKey.sso:
            {
              /**
               * 私有化下且已获取到企业id：
               * 单租户：不需要打开sso弹窗，默认取第一条企业
               * 多租户：需要打开sso弹窗，用户选择企业
               * */
              if (IS_PRIVATE && store.getters.corpList.length === 1) {
                ssoMethods.initList();
                ssoMethods.openSSOUrl();
                return;
              }
              // 自定义域名不需要打开sso弹窗
              if (isCustomizedDomain || domainPrefix) {
                const domain = [domainPrefix, currentDomain].filter(v => v).join('.');
                ssoMethods.openSSOUrl({ domain });
                return;
              }
              context.emit('change', transformKeyMap[entrance] || entrance);
            }
            break;
          case EntranceKey.yufuIdaas:
            {
              // 自定义域名不需要打开sso弹窗
              if (isCustomizedDomain || domainPrefix) {
                yufuMethods.initData();
                return;
              }
              context.emit('change', transformKeyMap[entrance] || entrance);
            }
            break;
          default:
            context.emit('change', transformKeyMap[entrance] || entrance);
            break;
        }
      },
    };

    methods.initData();

    return {
      LoginTypeKeyMap,
      LoginActionKeyMap,

      ldapInitInfo: {
        step,
        loginConfigList,
        ldapType,
        loginFlag,
      },

      wecomConfig,
      isInMoreEntrance,

      renderMap,
      ...methods,
    };
  },
});
